<script>
import Title from "@/components/admin/common/TitleArea.vue"
import StatusBadge from "@/components/fulfillment/StatusBadge.vue"
import DataTable from "@/components/fulfillment/DataTable.vue"
import PageGuideDialog from "@/components/admin/fulfillment/guide/PageGuideDialog.vue"
import FulfillmentPageGuide from "@/components/admin/fulfillment/guide/FulfillmentPageGuide.vue"

const TAB_OPTIONS = [
  { name: 'requested', label: '요청 · 대기' },
  { name: 'rejected', label: '요청 · 반려' },
  { name: 'pending', label: '매핑 · 연결 검토' },
  { name: 'mapped', label: '매핑 · 정상 연결' },
]
const TAB_NAMES = TAB_OPTIONS.map(tab => tab.name)

export default {
  name: 'RequestMappingManage',
  components: {
    Title,
    StatusBadge,
    DataTable,
    PageGuideDialog,
    FulfillmentPageGuide,
  },
  data() {
    return {
      description: {
        title: '요청/매핑 관리'
      },
      activeTab: 'requested',
      filters: {
        q: '',
      },
      sort: '',
      loading: false,
      guideDialog: false,
      rows: [],
      pagination: { page: 1, rowsPerPage: 20 },
    }
  },
  computed: {
    tabOptions() {
      return TAB_OPTIONS
    },
    currentColumns() {
      if (this.activeTab === 'requested') {
        return [
          { name: 'status', label: '상태', field: 'status', align: 'center' },
          { name: 'request_id', label: '요청 ID', field: 'request_id', align: 'right' },
          { name: 'partner_name', label: '파트너', field: row => row.partner_name || `#${row.partner_id}`, align: 'left' },
          { name: 'partner_sku_code', label: '파트너 SKU', field: 'partner_sku_code', align: 'left' },
          { name: 'barcode', label: '바코드', field: row => row.barcode || '-', align: 'left' },
          { name: 'brand_category', label: '브랜드/카테고리', field: row => `${row.brand_name || ''}/${row.category_name || ''}`, align: 'left' },
          { name: 'spec_type', label: '규격 타입', field: 'spec_type', align: 'center' },
          { name: 'spec_key', label: '상품 식별키', field: 'spec_key', align: 'left' },
          { name: 'created_at', label: '요청일', field: row => this.formatDateTime(row.created_at), align: 'left' },
        ]
      }

      if (this.activeTab === 'rejected') {
        return [
          { name: 'status', label: '상태', field: 'status', align: 'center' },
          { name: 'request_id', label: '요청 ID', field: 'request_id', align: 'right' },
          { name: 'partner_name', label: '파트너', field: row => row.partner_name || `#${row.partner_id}`, align: 'left' },
          { name: 'partner_sku_code', label: '파트너 SKU', field: 'partner_sku_code', align: 'left' },
          { name: 'barcode', label: '바코드', field: row => row.barcode || '-', align: 'left' },
          { name: 'brand_category', label: '브랜드/카테고리', field: row => `${row.brand_name || ''}/${row.category_name || ''}`, align: 'left' },
          { name: 'reject_reason', label: '반려 사유', field: row => row.reject_reason || '-', align: 'left' },
          { name: 'updated_at', label: '최근 변경일', field: row => this.formatDateTime(row.updated_at || row.created_at), align: 'left' },
        ]
      }

      return [
        { name: 'mapping_status', label: '연결 상태', field: 'mapping_status', align: 'center' },
        { name: 'partner_name', label: '파트너명', field: row => row.partner_name || `#${row.partner_id ?? '-'}`, align: 'left' },
        { name: 'partner_sku_code', label: '파트너 SKU', field: 'partner_sku_code', align: 'left' },
        { name: 'barcode', label: '바코드', field: row => row.barcode || '-', align: 'left' },
        { name: 'relation_source', label: '처리 유형', field: row => row.request_id ? '요청 건' : '기연결', align: 'center' },
        { name: 'display_name', label: '대상 상품', field: 'display_name', align: 'left' },
        { name: 'master_sku_code', label: '대상 마스터 SKU', field: 'master_sku_code', align: 'left' },
        { name: 'request_updated_at', label: '최근 변경일', field: row => this.formatDateTime(row.request_updated_at || row.updated_at), align: 'left' },
        { name: 'actions', label: '액션', field: 'actions', align: 'center' },
      ]
    },
  },
  watch: {
    activeTab() {
      this.syncRouteTab()
      this.pagination.page = 1
      this.loadList()
    },
    '$route.query.tab'() {
      this.applyRouteContext()
    }
  },
  methods: {
    syncRouteTab() {
      if (this.$route?.query?.tab === this.activeTab) return
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          tab: this.activeTab
        }
      }).catch(() => {})
    },
    applyRouteContext() {
      const routeTitle = String(this.$route?.meta?.title || '').replace(/^Aone 관리자 \|\s*/, '')
      if (routeTitle) {
        this.description.title = routeTitle
      }
      const routeTab = String(this.$route?.query?.tab || '')
      this.sort = String(this.$route?.query?.sort || '')
      if (TAB_NAMES.includes(routeTab) && routeTab !== this.activeTab) {
        this.activeTab = routeTab
      }
    },
    normalizeRows(data) {
      const items = Array.isArray(data)
        ? data
        : Array.isArray(data?.items)
          ? data.items
          : Array.isArray(data?.list)
            ? data.list
            : []

      if (this.activeTab === 'requested' || this.activeTab === 'rejected') {
        return items
      }

      return items.map((row, index) => ({
        ...row,
        row_key: `${row.master_sku_id || 'm'}-${row.partner_id || 'p'}-${row.partner_sku_code || 'sku'}-${row.mapping_status || 'status'}-${index}`
      }))
    },
    buildRequestUrl(status) {
      const query = new URLSearchParams({
        status,
        q: this.filters.q || '',
        page: String(this.pagination.page),
        pageSize: String(this.pagination.rowsPerPage),
      })
      if (this.sort && this.activeTab === 'requested') {
        query.set('sort', this.sort)
      }
      return `/api/fulfillment/admin/sku-requests?${query.toString()}`
    },
    buildMappingUrl(status) {
      const query = new URLSearchParams({
        status,
        q: this.filters.q || '',
        page: String(this.pagination.page),
        pageSize: String(this.pagination.rowsPerPage),
      })
      return `/api/fulfillment/admin/master-skus/mappings?${query.toString()}`
    },
    getListConfig() {
      if (this.activeTab === 'requested') {
        return {
          method: 'GET',
          url: this.buildRequestUrl('REQUESTED'),
          name: '[ Fulfillment / 요청 대기 목록 ]'
        }
      }
      if (this.activeTab === 'rejected') {
        return {
          method: 'GET',
          url: this.buildRequestUrl('REJECTED'),
          name: '[ Fulfillment / 반려 목록 ]'
        }
      }
      if (this.activeTab === 'pending') {
        return {
          method: 'GET',
          url: this.buildMappingUrl('PENDING'),
          name: '[ Fulfillment / 연결 검토 목록 ]'
        }
      }
      return {
        method: 'GET',
        url: this.buildMappingUrl('MAPPED'),
        name: '[ Fulfillment / 정상 연결 목록 ]'
      }
    },
    async loadList() {
      this.loading = true
      const config = this.getListConfig()
      await this.$http(config)
        .then((res) => {
          this.rows = this.normalizeRows(res.data?.data)
        })
        .catch(() => {
          this.rows = []
        })
      this.loading = false
    },
    onSearch() {
      this.pagination.page = 1
      this.loadList()
    },
    formatDateTime(value) {
      return value ? this.$formatDate(value, 'YYYY-MM-DD HH:mm:ss') : '-'
    },
    goToAction(row) {
      if (!row) return
      if (row.request_id) {
        this.$router.push({
          path: `/admin/fulfillment/approvals/${row.request_id}`,
          query: {
            returnQuery: JSON.stringify(this.$route.query || {})
          }
        })
        return
      }
      if (!row.master_sku_id) return
      this.$router.push(`/admin/fulfillment/master-skus/${row.master_sku_id}`)
    },
    onRowClick({ row }) {
      this.goToAction(row)
    }
  },
  mounted() {
    this.applyRouteContext()
    if (!TAB_NAMES.includes(String(this.$route?.query?.tab || ''))) {
      this.syncRouteTab()
    }
    this.loadList()
  }
}
</script>

<template>
  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        <Title :desc="description">
          <template #title-action>
            <q-btn flat round dense size="sm" color="primary" icon="help_outline" aria-label="요청/매핑 관리 사용 가이드" @click="guideDialog = true">
              <q-tooltip>요청/매핑 관리 사용 가이드</q-tooltip>
            </q-btn>
          </template>
          <q-btn flat round dense color="primary" icon="refresh" aria-label="새로고침" @click="loadList">
            <q-tooltip>새로고침</q-tooltip>
          </q-btn>
        </Title>
      </div>
    </div>

    <div class="comp-box q-pa-md q-mb-md">
      <div class="text-body2 text-grey-7 q-mb-sm">
        파트너 상품 요청을 처리하고, 파트너 SKU와 기준 상품의 연결 상태를 확인합니다.
      </div>
      <q-tabs
        v-model="activeTab"
        align="left"
        active-color="primary"
        indicator-color="primary"
        dense
      >
        <q-tab v-for="tab in tabOptions" :key="tab.name" :name="tab.name" :label="tab.label" />
      </q-tabs>

      <q-separator class="q-my-md" />

      <div class="row q-col-gutter-md">
        <div class="col-12 col-md-9">
          <q-input
            v-model="filters.q"
            :label="activeTab === 'requested' || activeTab === 'rejected'
              ? '검색 (파트너 SKU / 바코드 / 파트너명 / 브랜드 / spec key)'
              : '검색 (파트너 SKU / 바코드 / 파트너명 / 상품명 / 마스터 SKU)'"
            dense
            outlined
            @keyup.enter="onSearch"
          />
        </div>
        <div class="col-12 col-md-3">
          <q-btn color="primary" label="검색" class="full-width" @click="onSearch" />
        </div>
      </div>
    </div>

    <div class="comp-box">
      <DataTable
        :rows="rows"
        :columns="currentColumns"
        :row-key="activeTab === 'requested' || activeTab === 'rejected' ? 'request_id' : 'row_key'"
        :loading="loading"
        :pagination="pagination"
        @row-click="onRowClick"
      >
        <template #body-cell-status="props">
          <q-td :props="props">
            <StatusBadge :status="props.value" />
          </q-td>
        </template>
        <template #body-cell-mapping_status="props">
          <q-td :props="props">
            <StatusBadge :status="props.value" />
          </q-td>
        </template>
        <template #body-cell-actions="props">
          <q-td :props="props">
            <q-btn
              flat
              dense
              color="primary"
              :label="props.row.request_id ? '요청 보기' : '상품 보기'"
              @click.stop="goToAction(props.row)"
            />
          </q-td>
        </template>
        <template #no-data>
          <div class="full-width column flex-center q-pa-xl text-grey-7">
            <q-icon name="inbox" size="36px" class="q-mb-sm" />
            <div class="text-body2">현재 탭에 표시할 항목이 없습니다.</div>
            <div class="text-caption q-mt-xs">다른 탭을 선택하거나 검색 조건을 변경하세요.</div>
          </div>
        </template>
      </DataTable>
    </div>

    <PageGuideDialog
      v-model="guideDialog"
      title="요청/매핑 관리 사용 가이드"
      description="파트너 요청 처리와 연결 상태 확인 방법입니다."
    >
      <FulfillmentPageGuide guide-key="requestMappings" />
    </PageGuideDialog>
  </q-page>
</template>
